import React, { useState, useEffect } from 'react';
import { onAuthChange, ADMIN_EMAIL } from './firebase';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import Invoices from './pages/Invoices';
import Expenses from './pages/Expenses';
import Reports from './pages/Reports';
import Contact from './pages/Contact';
import Aging from './pages/Aging';
import ProfitLoss from './pages/ProfitLoss';
import BalanceSheet from './pages/BalanceSheet';
import Ledgers from './pages/Ledgers';
import TrialBalance from './pages/TrialBalance';
import Voucher from './pages/Voucher';
import CashRegister from './pages/CashRegister';
import Payables from './pages/Payables';
import Parties from './pages/Parties';
import ReceiptPayment from './pages/ReceiptPayment';
import Landing from './pages/Landing';
import FreeTools from './pages/FreeTools';
import DailySales from './pages/DailySales';
import BulkUpload from './pages/BulkUpload';
import CompanySettings from './pages/CompanySettings';
import BackupExport from './pages/BackupExport';
import Layout from './components/Layout';
import { LogoMark } from './components/Logo';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState('dashboard');
  const [authPage, setAuthPage] = useState('login');
  const [publicView, setPublicView] = useState('landing'); // landing | tools | auth

  useEffect(() => {
    const unsub = onAuthChange(u => { setUser(u); setLoading(false); });
    return unsub;
  }, []);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'linear-gradient(160deg, #0a3d2e 0%, #0f6e56 60%, #1d9e75 100%)' }}>
      <div style={{ textAlign:'center' }}><LogoMark dark /></div>
    </div>
  );

  if (!user) {
    if (publicView === 'landing') return <Landing onGetStarted={() => { setAuthPage('register'); setPublicView('auth'); }} onLogin={() => { setAuthPage('login'); setPublicView('auth'); }} onTools={() => setPublicView('tools')} />;
    if (publicView === 'tools') return <FreeTools onGetStarted={() => { setAuthPage('register'); setPublicView('auth'); }} />;
    return authPage === 'login'
      ? <Login onSwitch={() => setAuthPage('register')} onHome={() => setPublicView('landing')} />
      : <Register onSwitch={() => setAuthPage('login')} onHome={() => setPublicView('landing')} />;
  }

  if (user.email === ADMIN_EMAIL) return <AdminDashboard user={user} onLogout={() => setUser(null)} />;

  if (page === 'contact') return <Contact onBack={() => setPage('dashboard')} />;

  return (
    <Layout page={page} setPage={setPage} user={user}>
      {page === 'dashboard' && <Dashboard user={user} setPage={setPage} />}
      {page === 'invoices' && <Invoices user={user} />}
      {page === 'expenses' && <Expenses user={user} />}
      {page === 'parties' && <Parties user={user} />}
      {page === 'receipts' && <ReceiptPayment user={user} mode="receipt" />}
      {page === 'payments' && <ReceiptPayment user={user} mode="payment" />}
      {page === 'pettycash' && <CashRegister user={user} collectionName="pettycash" title="Petty Cash" subtitle="Track small daily cash transactions" inLabel="Cash In" outLabel="Cash Out" inType="in" outType="out" accent="#0f6e56" />}
      {page === 'cashbook' && <CashRegister user={user} collectionName="cashbook" title="Cash Book" subtitle="Daily cash inflow and outflow register" inLabel="Receipt" outLabel="Payment" inType="in" outType="out" accent="#185fa5" />}
      {page === 'bankbook' && <CashRegister user={user} collectionName="bankbook" title="Bank Book" subtitle="Bank deposits, withdrawals and running balance" inLabel="Deposit" outLabel="Withdrawal" inType="deposit" outType="withdrawal" accent="#534ab7" />}
      {page === 'receivables' && <Payables user={user} mode="receivable" />}
      {page === 'payables' && <Payables user={user} mode="payable" />}
      {page === 'ledgers' && <Ledgers user={user} />}
      {page === 'voucher' && <Voucher user={user} />}
      {page === 'aging' && <Aging user={user} />}
      {page === 'profitloss' && <ProfitLoss user={user} />}
      {page === 'balancesheet' && <BalanceSheet user={user} />}
      {page === 'trialbalance' && <TrialBalance user={user} />}
      {page === 'reports' && <Reports user={user} />}
      {page === 'dailysales' && <DailySales user={user} />}
      {page === 'bulkupload' && <BulkUpload user={user} />}
      {page === 'settings' && <CompanySettings user={user} />}
      {page === 'backup' && <BackupExport user={user} />}
    </Layout>
  );
}
